import * as React from 'react'
import * as PropTypes from 'prop-types'
import { styled } from 'next-yak'

import * as colors from '../constants/colors.ts'
import * as utils from '../utils'

import { Button } from '../components/index.ts'
import Icon from './Icon.jsx'
import LabelWithIcon from './LabelWithIcon.jsx'

import * as spinner from '../styles/spinner.tsx'
import * as button from '../styles/button.tsx'

const LightIcon = styled(Icon)`
  color: ${colors.PRIMARY_GREY_500};
`

/** This component should be used to trigger fetching more items in a list */
const LoadMoreButton = ({ loading, error, onClick, translations }) => {
  return (
    <OutlinedLoadMoreButton loading={loading} onClick={onClick} type="button">
      {error ? (
        <LabelWithIcon icon={<LightIcon glyph="refresh" size={16} />} label={translations['errorLabel']} />
      ) : (
        translations['initialLabel']
      )}
    </OutlinedLoadMoreButton>
  )
}

const OutlinedLoadMoreButton = styled(Button)`
  text-transform: none;
  color: ${(props) => utils.colors.primary(props)};
  background-color: ${colors.PRIMARY_GREY_000};
  border-radius: 2px;
  border: 2px solid;
  border-color: ${(props) => utils.colors.primary(props)};

  &:hover {
    background-color: ${colors.PRIMARY_GREY_000};
    border-color: ${(props) => utils.colors.primaryHover(props)};
    color: ${(props) => utils.colors.primaryHover(props)};
  }

  ${button.Label} {
    font-weight: 500;
  }

  ${spinner.Dot} {
    background-color: ${(props) => utils.colors.primary(props)};
  }
`

LoadMoreButton.defaultProps = {
  loading: false,
  error: false,
}

LoadMoreButton.propTypes = {
  /** controls loading mode of component */
  loading: PropTypes.bool,
  /** controls error mode of component */
  error: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  translations: PropTypes.shape({
    initialLabel: PropTypes.string.isRequired,
    loadingLabel: PropTypes.string,
    errorLabel: PropTypes.string.isRequired,
  }).isRequired,
}

export default LoadMoreButton
